"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var StyledLink = styled_components_1.default(react_router_dom_1.Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  &:hover {\n    color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  svg {\n    fill: ", ";\n  }\n\n  text-decoration: none;\n  display: inline-block;\n"], ["\n  color: ", ";\n  &:hover {\n    color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  svg {\n    fill: ", ";\n  }\n\n  text-decoration: none;\n  display: inline-block;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.link.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.link.hover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.link.hover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.link.color;
});
StyledLink.displayName = 'Link';
exports.default = StyledLink;
var templateObject_1;
//# sourceMappingURL=link.component.js.map